import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn, Wordmark } from '@castinflow/ui';
import { tr } from '../i18n/tr';

/**
 * Oturum dışı sayfalar (giriş, kayıt, sistem durumu): ortalanmış tek sütun. v3.5: ürün kimliği üstte koyu teal marka
 * şeridinde (uygulama menüsüyle aynı yüzey); içerik açık zeminde — şerit içeriğin arkasına girmez (başlığı kartın dışında
 * olan sayfalar da okunur). Fotoğraf/görsel kullanılmaz.
 */
export function PublicLayout({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="bg-sidebar px-4">
        <div
          className={cn('mx-auto flex h-16 w-full items-center', wide ? 'max-w-lg' : 'max-w-sm')}
        >
          <Link
            to="/login"
            className="inline-flex rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-accent focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar"
          >
            <Wordmark tone="inverse" />
            <span className="sr-only"> — {tr.auth.loginTitle}</span>
          </Link>
        </div>
      </header>
      <main
        id="main-content"
        tabIndex={-1}
        className={cn(
          'mx-auto w-full px-4 py-8 focus:outline-none sm:py-12',
          wide ? 'max-w-[calc(32rem+2rem)]' : 'max-w-[calc(24rem+2rem)]',
        )}
      >
        {children}
      </main>
    </div>
  );
}

/** Oturum dışı içerik kartı */
export function PublicCard({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-lg border border-border bg-surface p-5 shadow-card sm:p-7">
      {children}
    </div>
  );
}
